import { Badge, fmt } from "@nabble/ui";
import type { AdminDataRequest } from "../../../api/adminDataRequests";
import { isAnswered } from "../../../model/dataRequests";

/** A request's deadline, flagged when it is overdue or was extended (muted once answered). */
export function Deadline({ request: r }: { request: AdminDataRequest }): React.JSX.Element {
  if (isAnswered(r.status)) return <span className="nb-subtle">{fmt.date(r.dueAt)}</span>;
  return (
    <span className="nb-row" style={{ gap: 6, flexWrap: "wrap" }}>
      <span>{fmt.date(r.dueAt)}</span>
      {r.overdue ? <Badge label="Overdue" tone="danger" /> : null}
      {r.extended ? <Badge label="Extended" tone="info" dot={false} /> : null}
    </span>
  );
}
